import { Controller } from '@hotwired/stimulus'
import Tagify from '@yaireo/tagify'
import '@yaireo/tagify/dist/tagify.css'

export default class extends Controller {
  static values = {
    position: {
      type: String,
      default: 'all'
    }
  }

  static targets = ['input']

  get tagifyInstance () {
    return new Tagify(this.inputTarget, {
      originalInputValueFormat: (valuesArr) => valuesArr.map((item) => item.value).join(', '),
      tagTextProp: 'name',
      editTags: false,
      dropdown: {
        position: this.positionValue,
        enabled: 0,
        maxItems: 100,
        placeAbove: false,
        fuzzySearch: false
      },
      whitelist: JSON.parse(this.element.dataset.whitelist || '[]')
    })
  }

  connect () {
    this.tagify = this.tagifyInstance
    this.#setupInputListener()
  }

  disconnect () {
    this.tagify.off('input')
  }

  reload () {
    this.disconnect()
    this.connect()
  }

  #setupInputListener () {
    let controller = new AbortController()

    this.tagify.on('input', (event) => {
      const path = this.inputTarget.dataset.tagsPath

      if (path) {
        const { value } = event.detail
        this.tagify.settings.whitelist.length = 0

        controller.abort()
        controller = new AbortController()
        this.tagify.loading(true)

        fetch(`${path}?query=${value}`, { signal: controller.signal })
          .then((response) => response.json())
          .then((whitelist) => {
            this.tagify.whitelist = whitelist
            this.tagify.loading(false).dropdown.show(value)
          })
      }
    })
  }
}
